import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";

import { cn } from "../../../../lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary_lv text-primary_lv-foreground hover:bg-primary_lv/90",
        destructive: "bg-destructive_lv text-destructive_lv-foreground hover:bg-destructive_lv/90",
        outline: "border_lv border-input bg-background_lv hover:bg-accent_lv hover:text-accent_lv-foreground",
        secondary: "bg-secondary_lv text-secondary_lv-foreground hover:bg-secondary_lv/80",
        ghost: "hover:bg-accent_lv hover:text-accent_lv-foreground",
        link: "text-primary_lv underline-offset-4 hover:underline",
        love: "bg-love-pink text-love-pink-foreground hover:bg-love-pink/90 shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-105",
        mystical: "bg-mystical text-mystical-foreground hover:bg-mystical/90 shadow-lg transition-all duration-300",
        "love-outline": "border-2 border-love-pink text-love-pink bg-transparent hover:bg-love-pink hover:text-love-pink-foreground transition-all duration-300",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

const Button = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return <Comp className={cn(buttonVariants({ variant, size, className }))} ref={ref} {...props} />;
  },
);

Button.displayName = "Button";

export { Button, buttonVariants };